/*
 * View showing the table listing of values for a category
 */

define([
  "marionette",
  "underscore",
  "./template/categoryEntriesTemplate.html",
  "./template/categoryValueTemplate.html",
], function (Marionette, _, CategoryValuesTemplate, CategoryValueTemplate) {
  var CategoryValuesView = {};

  CategoryValuesView.CategoryValueView = Marionette.ItemView.extend({
    template: CategoryValueTemplate,
    tagName: "tr",
    triggers: {
      "click #valueDelete": "delete:value",
    },
    modelEvents: {
      "change value": "render",
      "change valueDescription": "render",
    },
    textboxes: function () {
      const selectedLanguageId = this.model.collection.selectedLanguageId;
      if (selectedLanguageId !== 0) {
        const localizedAttributeName = "localizedValue_" + selectedLanguageId;
        const textboxes = {};
        textboxes["#localizedValue_" + selectedLanguageId] = {
          enableSelector: "#" + localizedAttributeName,
          modelAttribute: localizedAttributeName,
          textArea: false,
          doNotModifyPlaceholder: true,
          placeholder: this.model.get("value"),
        };
        return textboxes;
      }
      return {
        "#value": {
          enableSelector: "#value",
          modelAttribute: "value",
          placeholder: "admin.categories.values.valueName",
          textArea: false,
        },
        "#valueDescription": {
          enableSelector: "#valueDescription",
          modelAttribute: "description",
          placeholder: "admin.categories.values.description",
          textArea: false,
        },
      };
    },
  });

  CategoryValuesView.categoryValuesView = Marionette.CompositeView.extend({
    template: CategoryValuesTemplate,
    itemView: CategoryValuesView.CategoryValueView,
    itemViewContainer: "tbody",
    triggers: {
      "click #addValue": "add:value",
    },
    collectionEvents: {
      sort: "renderSpecial",
    },
    emptyError: function (errorMessage) {
      this.$el
        .find("#valueError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    onAfterItemAdded: function (itemView) {
      //remove delete button if there is only one value
      if (this.collection.size() === 1) {
        itemView.$el.find("#valueDelete").html("");
      }
    },
    onItemRemoved: function () {
      //remove delete button if there's now only one view (entry)
      if (this.children.length === 1) {
        this.children.first().$el.find("#valueDelete").html("");
      }
    },
    renderSpecial: function () {
      //clear any tooltips and then re-render
      this.$el.find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]').tooltip("destroy");
      this.render();
    },
  });

  return CategoryValuesView;
});
